import { CampaignGeneration } from 'components/FirstTimeExperienceModal/steps/CampaignGeneration/CampaignGeneration'
import { CampaignGenerationResult } from 'components/FirstTimeExperienceModal/steps/CampaignGeneration/Types'
import { MultiStepPageLayout } from 'components/MultiStepFlow/MultiStepPageLayout/MultiStepPageLayout'
import { AutopilotSidebar } from 'components/FirstTimeExperienceModal/steps/CampaignGeneration/AutopilotSidebar'
import AutopilotRegistrationAndOnboardingStyles from 'screens/AutopilotRegistration/AutopilotRegistrationAndOnboarding.module.scss'

export interface CampaignQuestionsData {
  goals: string
  keyDates: string
  growth_goals_input?: string
  key_dates_input?: string
  selectedPlan?: 'growth' | 'starter'
}

export const CampaignQuestions = ({
  campaignQuestions,
  setCampaignQuestions,
  onNext,
  onBack,
  brandPlanId,
  brandKitId,
}: {
  campaignQuestions: CampaignQuestionsData
  setCampaignQuestions: (data: CampaignQuestionsData) => void
  onNext: () => void
  onBack: () => void
  brandPlanId?: number
  brandKitId?: number
}) => {
  const handleNext = (campaignData: CampaignGenerationResult) => {
    setCampaignQuestions({
      goals: campaignData.growth_goals_input,
      keyDates: campaignData.key_dates_input,
      growth_goals_input: campaignData.growth_goals_input,
      key_dates_input: campaignData.key_dates_input,
      selectedPlan: campaignData.selectedPlan,
    })
    onNext()
  }

  const initialValues: CampaignGenerationResult | undefined = campaignQuestions.growth_goals_input
    ? {
        growth_goals_input: campaignQuestions.growth_goals_input,
        key_dates_input: campaignQuestions.key_dates_input || '',
        selectedPlan: campaignQuestions.selectedPlan,
      }
    : undefined

  // Use MultiStepPageLayout to match onboarding styling with sidebar
  return (
    <MultiStepPageLayout
      currentStep={1}
      totalSteps={2}
      onBack={onBack}
      currentStepKey="campaign_questions"
      showBackButton={true}
      siderComponent={AutopilotSidebar}
      backgroundClassName={AutopilotRegistrationAndOnboardingStyles.cloudBackground}
    >
      <CampaignGeneration
        onBack={onBack}
        onNext={handleNext}
        initialValues={initialValues}
        brandPlanId={brandPlanId}
        brandKitId={brandKitId}
        skipSubscriptionUpdate={true}
        disablePlanChoice={true}
      />
    </MultiStepPageLayout>
  )
}
